const redPalette = {
  light: '#FFE9E9',
  main:  '#FFB2B2',
  dark:  '#8F4343'
};

export default redPalette;